import React from 'react';
import SectionHeader from './SectionHeader';
import FaqList from './FaqList';

const FaqSectionBlock = ({
    sectionClassName,
    sectionId,
    header,
    faqProps
}) => (
    <section id={sectionId} className={sectionClassName}>
        <div className="container">
            <SectionHeader
                wrapperClassName={header.wrapperClassName}
                subtitleClassName={header.subtitleClassName}
                titleClassName={header.titleClassName}
                descriptionClassName={header.descriptionClassName}
                subtitle={header.subtitle}
                title={header.title}
                description={header.description}
            />
            <FaqList {...faqProps} />
        </div>
    </section>
);

export default FaqSectionBlock;

